import { Component } from 'react';
import { ToggleViewBtn } from "@platform/base";
import { toast, ajax } from "@platform/api";

function queryPageAllInfo(data) {
    const url = `/nccloud/platform/templet/queryPageAllInfo.do`;
    return new Promise(resolve => {
        ajax({
            url,
            data,
            loading: true,
            success: res => {
                const { data = {} } = res;
                resolve(data);
            },
        });
    });
}

class TransferList extends Component {
    render() {
        let { _pageScope, moduleId, ...others } = this.props;
        others.transferListId = moduleId;
        others.isLowCode = true;
        return _pageScope.props.transferTable.createTransferList(others);
    }
}

class TransferTable extends Component {
    state = {
        currentTab: '0',
        toggleViewStatus: false,
    }

    componentDidMount() {
        const { currentTab } = this.state;
        if (this.tabs.length && this.loadTabId !== undefined) {
            if (this.tabs[currentTab].tabId === this.loadTabId) {
                this.onTabClick(currentTab, true);
            }
        }
    }

    loadTabId
    //页面上显示的页签
    tabs = []
    //引用页签对应的pageCode和appCode
    quoteTabPageInfo = new Map();

    //引用页签已经请求过模板的layout
    quoteTabMetaInfo = new Map();

    onToggleBtnClick = () => {
        console.log('onToggleBtnClick', this.state.currentTab);
        const { _pageScope } = this.props;
        this.setState({ toggleViewStatus: !this.state.toggleViewStatus });
        _pageScope.props.transferTable.changeViewType();
    }
    onTabClick = (tabKey, notClick) => {
        console.log(tabKey, 'tabKeytabKey');
        const { onTabClick, loadTabMeta, _pageScope } = this.props;
        const { meta } = _pageScope.props;
        let tabId = this.tabs[Number(tabKey)].tabId;
        // 如果是引用页签，需要先去请求模板
        if (this.quoteTabPageInfo.has(tabId)) {
            if (this.quoteTabMetaInfo.has(tabId)) {
                //已经请求过了 执行业务回调
                !notClick && typeof onTabClick === 'function' && onTabClick(tabId);
            } else {
                //没有的话，先请求模板
                queryPageAllInfo(this.quoteTabPageInfo.get(tabId)).then(res => {
                    let allMeta = meta.getMeta();
                    //合并模板，如果有重复就先提示重复
                    console.log(res, allMeta);
                    let templet = res.templet;
                    let tabMeta = {};
                    for (const key of Object.keys(templet)) {
                        const element = templet[key];
                        if (Array.isArray(element.items)) {
                            if (allMeta[key]) {
                                toast({ color: 'warning', content: '区域' + key + '重复' });
                            }
                            tabMeta[key] = element;
                        }
                    }
                    if (!templet.layout) {
                        toast({ color: 'warning', content: "该引用页签没有设计新页面" });
                        return;
                    }
                    let layout = JSON.parse(templet.layout);
                    //存引用模板的layout
                    if (Array.isArray(layout)) {
                        let tabsConfig = layout.find(i => i.name === 'NCTransferTable').props.tabsConfig[0];
                        this.quoteTabMetaInfo.set(tabId, {
                            bodyTableId: tabsConfig.bodyTableId,
                            fullTableId: tabsConfig.fullTableId,
                            headTableId: tabsConfig.headTableId,
                            searchConfig: tabsConfig.searchConfig,
                            searchId: tabsConfig.searchId,
                        });
                    }
                    meta.addMeta(tabMeta);
                    //执行业务loadTabMeta方法，用于业务初始化修改模板
                    typeof loadTabMeta === 'function' && loadTabMeta(tabId, templet);
                    // 执行业务切换页签回调
                    !notClick && typeof onTabClick === 'function' && onTabClick(tabId);
                });
            }
        } else {
            !notClick && typeof onTabClick === 'function' && onTabClick(tabId);
        }
        !notClick && this.setState({ currentTab: tabKey });
    }

    render() {
        let { _pageScope, moduleId, ...config } = this.props;
        const {
            meta,
            transferTable,
            search,
        } = _pageScope.props;
        const { toggleViewStatus, currentTab } = this.state;
        const { createTransferTable, createMultiTransferTable } = transferTable;
        //转单不需要moduleId,先按照固定页面结构解析  title  search  table
        const metaData = meta.getMeta();
        let { transferSign = '1', titleSlot, tabsConfig, tabsProps, showChangeViewBtn = true, quoteTemplates = {}, showAll = true, showTabList, ...others } = config;
        //兼容tabsConfig
        if (Array.isArray(tabsConfig)) {
            tabsConfig = tabsConfig.map(tab => {
                let { bodyTableItems, fullTableItems, headTableItems, searchConfig, ...others } = tab;
                if (bodyTableItems?.value) {
                    others.bodyTableId = bodyTableItems.code;
                }
                if (fullTableItems?.value) {
                    others.fullTableId = fullTableItems.code;
                }
                if (headTableItems?.value) {
                    others.headTableId = headTableItems.code;
                }
                if (searchConfig?.searchItems) {
                    searchConfig.moduleId = searchConfig.searchItems.code;
                    others.searchId = searchConfig.searchItems.code;
                }
                others.searchConfig = searchConfig;
                return { ...others };
            });
        }
        /**
            //业务传的结构
            tabsProps = {
                tabId: {
                    //创建查询区的属性
                    searchId: {
                        clickSearchBtn: () => { },
                        onAfterEvent: () => { }
                    },
                    //转单属性
                    headTableId: {

                    },
                }
            };
         */

        let ret = null;
        let selectedShow;
        let head = <div className='transfer-head'>{titleSlot}{showChangeViewBtn && <div className='transfer-toggle-btn'><ToggleViewBtn expand={toggleViewStatus} onClick={this.onToggleBtnClick} /></div>}</div>;
        // 1.单来源   2.多来源
        if (transferSign === '1') {
            let { tabId, searchId, searchConfig, ...tabOthers } = tabsConfig[0];
            //判断是否有模板 只判断页签下的headTableId模板
            let firstTabHeadTableId = tabsConfig[0]?.['headTableId'];
            let tableMetaData = firstTabHeadTableId && metaData[firstTabHeadTableId];
            if (tableMetaData) {
                let searchArea = null;
                selectedShow = transferTable.getSelectedListDisplay(tabOthers.headTableId);
                //查看已选不显示title和查询区
                if (selectedShow) {
                    head = null;
                } else {
                    searchArea = <div className='lowcode-search'>{search.NCCreateSearch(searchId, {
                        //设计器配置的查询区配置项
                        ...searchConfig,
                        //业务传进来的查询区配置
                        ...(typeof tabsProps?.[tabId]?.[searchId] === 'object' ? tabsProps[tabId][searchId] : {}),
                    })}</div>;
                }
                ret = (<div className='lowcode-transfertable'>{head}{searchArea}<div className='lowcode-table'>{createTransferTable({ onChangeViewClick: this.onToggleBtnClick, ...tabOthers, ...others, ...(typeof tabsProps?.[tabId]?.[firstTabHeadTableId] === 'object' ? tabsProps[tabId][firstTabHeadTableId] : {}) })}</div></div >);
            }
        } else if (transferSign === '2') {
            let allTabConfig = {}; //全部页签配置
            let mergeConfig = [];
            tabsConfig.forEach(({ tabId, searchId, headTableId, bodyTableId, fullTableId, tabName, isAllTab, searchConfig = {} }) => {
                let config = { tabId, tabName };
                if (bodyTableId) {
                    config.bodyTableId = bodyTableId;
                }
                if (fullTableId) {
                    config.fullTableId = fullTableId;
                }
                if (headTableId) {
                    config.headTableId = headTableId;
                }
                //说明是全部页签
                if (showAll && isAllTab) {
                    allTabConfig.showAll = true;
                    allTabConfig.allHeadId = headTableId;
                    allTabConfig.allBodyId = bodyTableId;
                    allTabConfig.allFullTableId = fullTableId;
                }
                //存储引用页签的信息 主要是appcode，pagecode，templetid用于请求模板数据
                let quoteTemp = quoteTemplates[tabId];
                if (quoteTemp) {
                    this.quoteTabPageInfo.set(tabId, {
                        appcode: quoteTemp.originapp,
                        pagecode: quoteTemp.originpage,
                        // templetid: quoteTemp.templateid
                    });
                    if (this.quoteTabMetaInfo.has(tabId)) {
                        config = { ...config, ...this.quoteTabMetaInfo.get(tabId) };
                        searchId = config.searchId;
                    }
                }
                // 创建查询区，合并查询区配置项
                if (searchId !== null && metaData[searchId]) {
                    config.searchArea = () => {
                        return search.NCCreateSearch(searchId, {
                            //设计器配置的查询区配置项
                            ...searchConfig,
                            //业务传进来的查询区配置
                            ...(typeof tabsProps?.[tabId]?.[searchId] === 'object' ? tabsProps[tabId][searchId] : {}),
                        });
                    };
                } else {
                    config.searchArea = () => {
                        return <div></div>;
                    };
                }
                if (Array.isArray(showTabList)) {
                    if (showTabList.includes(tabId)) {
                        mergeConfig.push(config);
                    }
                } else {
                    mergeConfig.push(config);
                }
            });
            if (mergeConfig.length) {
                this.tabs = mergeConfig;
                //判断是否有模板 只判断页签下的headTableId模板
                let firstTabHeadTableId = mergeConfig[0]?.headTableId;
                let tableMetaData = firstTabHeadTableId && metaData[firstTabHeadTableId];
                if (tableMetaData) {
                    //根据页签的数量确定是创建多来源转单还是单来源转单
                    if (mergeConfig.length === 1 && showAll !== true) {
                        let { headTableId, searchId, searchConfig = {}, tabId } = mergeConfig[0];
                        selectedShow = transferTable.getSelectedListDisplay(headTableId);
                        let searchArea = null;
                        //查看已选不显示title和查询区
                        if (selectedShow) {
                            head = null;
                        } else {
                            searchArea = <div className='lowcode-search'>{search.NCCreateSearch(searchId, {
                                //设计器配置的查询区配置项
                                ...searchConfig,
                                //业务传进来的查询区配置
                                ...(typeof tabsProps?.[tabId]?.[searchId] === 'object' ? tabsProps[tabId][searchId] : {}),
                            })}</div>;
                        }
                        ret = (<div className='lowcode-transfertable'>{head}{searchArea}<div className='lowcode-table'> {createTransferTable({ onChangeViewClick: this.onToggleBtnClick, ...mergeConfig[0] })}</div></div>);
                    } else {
                        let headTableId = mergeConfig[Number(currentTab)]?.headTableId;
                        if (showAll) {
                            selectedShow = transferTable.getSelectedListDisplay('all');
                        } else {
                            selectedShow = transferTable.getSelectedListDisplay(headTableId);
                        }
                        //查看已选不显示title
                        if (selectedShow) { head = null; }
                        ret = (<div className='lowcode-transfertable'>{head}<div className='lowcode-table'>{createMultiTransferTable({ ...allTabConfig, ...others, onChangeViewClick: this.onToggleBtnClick, onTabClick: this.onTabClick }, mergeConfig)}</div></div>);
                    }
                } else {
                    this.loadTabId = mergeConfig[0].tabId;
                }
            }

        }
        return ret;
    }
}
export { TransferTable, TransferList };